export default __webpack_public_path__ + "static/FReg-4x3-S_SponsoredChallenge-3d01851fdf7f4d898b4526702e04d2b3.jpg";